import { sharedLocalStorage } from '@/shared/helpers';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
const getPaletteModeFromStorage = () => {
    const storedValue = sharedLocalStorage.getItem('paletteMode');
    if (storedValue === 'light' || storedValue === 'dark')
        return storedValue;
    return 'light';
};
export const getSidebarCollapsedValueFromStorage = () => (sharedLocalStorage.getItem('sidebarCollapsed') || false) === 'true';
const initialState = {
    sidebarCollapsed: getSidebarCollapsedValueFromStorage(),
    paletteMode: getPaletteModeFromStorage(),
    warehouseUrlAccessDeniedMessage: undefined,
};
const useLayoutStore = create()(immer((set) => ({
    ...initialState,
    toggleSidebarWidth: (preventStorage) => {
        set((state) => {
            const newValue = !state.sidebarCollapsed;
            state.sidebarCollapsed = newValue;
            if (!preventStorage) {
                sharedLocalStorage.setItem('sidebarCollapsed', newValue.toString());
            }
        });
    },
    restoreSidebarWidth: () => {
        set((state) => {
            state.sidebarCollapsed = getSidebarCollapsedValueFromStorage();
        });
    },
    togglePaletteMode: () => {
        set((state) => {
            const newValue = state.paletteMode === 'light' ? 'dark' : 'light';
            state.paletteMode = newValue;
            sharedLocalStorage.setItem('paletteMode', newValue.toString());
        });
    },
    saveWarehouseAccessDeniedMessage: (value) => {
        set((state) => {
            state.warehouseUrlAccessDeniedMessage = value;
        });
    },
})));
export { useLayoutStore };
